import { Loader2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { darken, useCtaPress } from './shared';
import type { TemplateProps } from './types';

const DEFAULT_COLOR = '#1677FF';

/**
 * Custom (自定义背景图) 模板：logoUrl 语义为背景图完整 URL（cover 铺满视口，
 * 未配置/未加载时纯色兜底），appName 语义为按钮文字。CTA 固定在底部 safe-area 内，
 * 状态机与 pointerType 分发同 Download。
 */
export function CustomTemplate({ state, onAccept, appName, logoUrl, buttonColor }: TemplateProps) {
  const { t } = useTranslation();
  const ready = state.status === 'awaiting-click';
  const { pressed, onClick } = useCtaPress(onAccept);
  const color = buttonColor?.trim() || DEFAULT_COLOR;

  return (
    <div className="relative min-h-dvh select-none" style={{ backgroundColor: '#111827' }}>
      {/* 背景图：绝对定位铺满；img 而非 css background 以便浏览器原生懒解码与错误兜底 */}
      {logoUrl && (
        <img
          src={logoUrl}
          alt=""
          aria-hidden
          className="absolute inset-0 h-full w-full object-cover"
          draggable={false}
        />
      )}

      {/* 底部 CTA */}
      <div
        className="absolute inset-x-0 bottom-0 flex justify-center px-8"
        style={{ paddingBottom: 'max(2rem, env(safe-area-inset-bottom))' }}
      >
        <button
          type="button"
          onClick={onClick}
          className="w-full max-w-xs rounded-full py-4 text-base font-bold text-white shadow-lg transition-all duration-200"
          style={
            ready
              ? {
                  backgroundColor: pressed ? darken(color) : color,
                  transform: pressed ? 'scale(0.98)' : 'scale(1)',
                }
              : { backgroundColor: '#9ca3af', cursor: 'default' }
          }
          disabled={!ready}
        >
          {ready ? (
            appName.trim() || t('custom.cta')
          ) : (
            <span className="flex items-center justify-center gap-2">
              <Loader2 className="h-4 w-4 animate-spin" />
              {t('custom.checking')}
            </span>
          )}
        </button>
      </div>
    </div>
  );
}
